import { useState, useEffect, useRef } from 'react';
import { useAuth } from 'src/contexts/auth';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import api from '../../services/api';
import {
    ModelOfUnity,
    ModelOfPrioritys,
    ModelOfVehicleItem,
    ModelOfPeople,
    ModelOfStock,
    ModelOfFuelType,
    ModelOfCreditor,
    ModelOfDriver,
    ModelOfMotoristaVeiculo,
} from '../../database';

import { AxiosResponse } from 'axios';

interface Priority {
    label: string;
    value: string;
}

interface filteredProps {
    label: string;
    value?: string;
}

interface filteredDemand {
    label: string;
    value?: number;
}

const DemandController = () => {
    const [unityList, setUnityList] = useState<ModelOfUnity[]>([]);
    const [managerList, setManagerList] = useState<ModelOfPeople[]>([]);
    const [vehicleList, setVehicleList] = useState<ModelOfVehicleItem[]>([]);
    const [driverList, setDriverList] = useState<ModelOfDriver[]>([])
    const [creditorsList, setCreditorsList] = useState<ModelOfCreditor[]>([]);
    const [priorityList, setPriotityList] = useState<ModelOfPrioritys[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [response, setResponse] = useState<AxiosResponse | null>(null);
    const [stocksList, setStocksList] = useState<ModelOfStock[]>([]);
    const [fuelTypesList, setFuelTypesList] = useState<ModelOfFuelType[]>([]);

    const { userAgencyId, people, userId, setDialogDemand, setDemand, authDemand, setAuthDemand } = useAuth();
    const toast: any = useRef();

    interface ModelOfRejectDemand {
        ORGAO: string;
        DESCRICAO: string;
        PRIORIDADE: string;
        PESSOA?: string;
        FT_MOTORISTA: string;
        FT_USUARIO: any;
        STATUS: number;
        DEMANDA: string;
    }
    interface ModelOfService {
        ID?: string;
        ORGAO: any;
        ORGAOUNIDADEDESTINO?: string;
        PESSOAORIGEM?: string;
        PESSOADESTINO?: string;
        FT_VEICULO: string;
        FT_USUARIO: any;
        DESCRICAO: string;
        TIPODEMANDA?: number;
        PRIORIDADE: string;
        ESTOQUE?: string;
        ITINERARIO?: string;
        QUANTIDADECOMBUSTIVELSOLICITADO?: number;
        FT_TIPOCOMBUSTIVEL?: string;
        STATUS?: number;
        QUANTIDADEAUTORIZADA?: number;
        QUANTIDADEITEM?: number;
        PESSOA?: string;
        FT_MOTORISTA?: string;
        DEMANDA?: string;
        PRECOCUSTO?: number;
        PRECOVENDA?: number;
        AX_PRODUTO?: string;
        AX_ESTOQUE?: string;
        MOTIVOVIAGEM?: string;
        DATAINICIO?: Date | null
        DATAFIM?: Date | null
    }

    interface ModelOfServiceCombustivel {
        ID?: string;
        ORGAO: any;
        PESSOAORIGEM?: string;
        FT_VEICULO: string;
        CREDOR: string;
        FT_USUARIO: any;
        FT_ESTOQUE?: string;
        FT_TIPOCOMBUSTIVEL: string,
        QUANTIDADECOMBSUTIVEL?: number;
        FT_MOTORISTA: string;
        VALORCOMBSUTIVEL?: number;
        DATA?: Date | null;
        DATAFIM?: Date | null;
    }

    const validationSchema = Yup.object().shape({
        ORGAO: Yup.string().required('Você precisa selecionar o órgão!'),
        DESCRICAO: Yup.string().required('Campo obrigatório!'),
        PRIORIDADE: Yup.string().required('Você precisa selecionar a prioridade!'),
        PESSOADESTINO: Yup.string().required('Você precisa selecionar o responsável!'),
    });
    const validationSchemaCombustivel = Yup.object().shape({
        ORGAO: Yup.string().required('Você precisa selecionar o órgão!'),
        FT_VEICULO: Yup.string().required('Campo obrigatório!'),
        FT_ESTOQUE: Yup.string().required('Campo obrigatório!'),
        FT_MOTORISTA: Yup.string().required('Você precisa selecionar o motorista!'),
        FT_TIPOCOMBUSTIVEL: Yup.string().required('Você precisa selecionar o tipo de combustível!'),
        VALORCOMBSUTIVEL: Yup.number().required('Você precisa informar o preço'),
        CREDOR: Yup.string().required('Você precisa selecionar o posto!'),
    });


    const formikCombustivel = useFormik<ModelOfServiceCombustivel>({
        initialValues: {
            ID: '',
            ORGAO: userAgencyId,
            PESSOAORIGEM: people,
            FT_VEICULO: '',
            CREDOR: '',
            FT_USUARIO: userId,
            FT_ESTOQUE: '',
            FT_TIPOCOMBUSTIVEL: '',
            QUANTIDADECOMBSUTIVEL: 0,
            FT_MOTORISTA: '',
            VALORCOMBSUTIVEL: 0,
            DATA: null,
            DATAFIM: null,
        },
        onSubmit: async values => postDemandCombustivel(values),
        validationSchema: validationSchemaCombustivel,
    })

    const formik = useFormik<ModelOfService>({
        initialValues: {
            ID: '',
            ORGAO: userAgencyId,
            ORGAOUNIDADEDESTINO: '',
            PESSOAORIGEM: people,
            PESSOADESTINO: '',
            FT_VEICULO: '',
            FT_USUARIO: userId,
            DESCRICAO: '',
            TIPODEMANDA: 0,
            PRIORIDADE: '',
            ESTOQUE: '',
            ITINERARIO: '',
            QUANTIDADECOMBUSTIVELSOLICITADO: 0,
            FT_TIPOCOMBUSTIVEL: '',
            STATUS: 0,
            QUANTIDADEAUTORIZADA: 0,
            QUANTIDADEITEM: 1,
            DATAINICIO: null,
            DATAFIM: null

            // ** STATUS 0 = ABERTO
            // ** STATUS 1 = ACEITA
            // ** STATUS 2 = RECUSADA
        },

        onSubmit: async values => postDemand(values),
        validationSchema: validationSchema,
    });

    const rejectDemandAdmin = async (item: any) => {
        const newRejectedRequestItem: ModelOfRejectDemand = {
            DEMANDA: item.ID,
            DESCRICAO: item.DESCRICAO,
            FT_MOTORISTA: item.PESSOAORIGEM,
            FT_USUARIO: userId,
            ORGAO: userAgencyId,
            PESSOA: people,
            PRIORIDADE: item.PRIORIDADE,
            STATUS: 1,
        };
        try {
            setLoading(true);

            await api.post('request/rejected', newRejectedRequestItem).then(response => {
                setResponse(response);
            });
            toast.current.show({
                severity: 'success',
                summary: 'A demanda foi recusada!',
                detail: 'A sua demanda foi recusada!',
                life: 5000,
            });
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Não foi possível rejeitar a demanda!',
                detail: 'Falha ao realizar operação!',
                life: 5000,
            });
        } finally {
            setLoading(false);
        }
    };
    const deleteDemand = async (id: any) => {
        try {
            await api.delete(`demands/delete/${id}`).then(res => {
                setResponse(res);
                toast.current.show({
                    severity: 'success',
                    summary: 'A demanda foi deletada!',
                    detail: 'A sua demanda foi deletada!',
                    life: 5000,
                });
            });
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'A demanda não foi deletada!',
                detail: 'Falha ao realizar operação!',
                life: 5000,
            });
        } finally {
            setDialogDemand(false);
            setLoading(false);
            setDemand(null);
        }
    };

    const postDemandCombustivel = async (values: ModelOfServiceCombustivel) => {
        console.log("inicio: ", values)
        console.log("inicio ID: ", values.ID)
        setLoading(true);
        if (values.ID === '') {
            try {
                delete values.ID
                await api.post('demandscombustivel', values).then(res => {
                    setResponse(res);
                    console.log("res: ", res)
                    console.log("Resposta do abastecimento:", res)
                    toast.current.show({
                        severity: 'success',
                        summary: 'A demanda foi cadastrada!',
                        detail: 'A sua demanda foi registrada.',
                        life: 5000,
                    });
                });

                setLoading(false);
            } catch (error) {
                toast.current.show({
                    severity: 'error',
                    summary: 'A demanda não foi cadastrada',
                    detail: 'Falha ao realizar operação!',
                    life: 5000,
                });
            }
        }
    };

    const postDemand = async (values: ModelOfService) => {
        console.log("autorizar combustivel")
        setLoading(true);
        if (authDemand) {
            const data = {
                ...values,

                PESSOA: values.PESSOADESTINO,
                FT_MOTORISTA: values.FT_USUARIO,
                FT_USUARIO: values.FT_USUARIO,
                STATUS: 0,
                DEMANDA: values.ID,
                QUANTIDADEITEM: 1,
                PRECOCUSTO: 0,
                PRECOVENDA: 0,
                AX_PRODUTO: values.FT_TIPOCOMBUSTIVEL,
                AX_ESTOQUE: values.ESTOQUE,
                MOTIVOVIAGEM: values.DESCRICAO,
                DATAINICIO: values.DATAINICIO,
                DATAFIM: values.DATAFIM,
            };

            delete data.PESSOADESTINO;
            delete data.PESSOAORIGEM;
            delete data.ID;
            delete data.ORGAOUNIDADEDESTINO;
            delete data.TIPODEMANDA;
            delete data.ESTOQUE;
            delete data.FT_TIPOCOMBUSTIVEL;
            try {
                console.log("Autoriando demanda de combustivel", data)
                await api.post('request', data).then(res => {
                    setResponse(res);
                    toast.current.show({
                        severity: 'success',
                        summary: 'A demanda demanda foi autorizada!',
                        detail: 'A sua demanda foi autorizada.',
                        life: 5000,
                    });
                });
            } catch (error) {
                toast.current.show({
                    severity: 'error',
                    summary: 'A demanda não foi autorizada!',
                    detail: 'Falha ao realizar operação!',
                    life: 5000,
                });
            } finally {
                setDialogDemand(false);
                setLoading(false);
                setDemand(null);
                setAuthDemand(false);
            }
        } else if (values.ID === '') {
            delete values.ID;
            delete values.QUANTIDADEAUTORIZADA;
            delete values.QUANTIDADEITEM;

            try {
                await api.post('demands', values).then(res => {
                    setResponse(res);
                    toast.current.show({
                        severity: 'success',
                        summary: 'A demanda foi cadastrada!',
                        detail: 'A sua demanda foi registrada.',
                        life: 5000,
                    });
                });

                setLoading(false);
            } catch (error) {
                toast.current.show({
                    severity: 'error',
                    summary: 'A demanda não foi cadastrada',
                    detail: 'Falha ao realizar operação!',
                    life: 5000,
                });
            }
        } else {
            delete values.QUANTIDADEAUTORIZADA;
            delete values.QUANTIDADEITEM;

            try {
                await api.put(`demands/update`, values).then(res => {
                    setResponse(res);
                    toast.current.show({
                        severity: 'success',
                        summary: 'A demanda foi cadastrada!',
                        detail: 'A sua demanda foi registrada.',
                        life: 5000,
                    });
                });

                setLoading(false);
            } catch (error) {
                toast.current.show({
                    severity: 'error',
                    summary: 'A demanda não foi cadastrada',
                    detail: 'Falha ao realizar operação!',
                    life: 5000,
                });
            } finally {
                setDialogDemand(false);
                setLoading(false);
                setDemand(null);
            }
        }
    };

    const getUnityList = async () => {
        const response = await api.post('agencys/all-unitys', {
            ORGAO: userAgencyId,
        });
        setUnityList(response.data);
    };

    const getManagerList = async () => {
        const response = await api.post('getManager', {
            ORGAOUNIDADE: formik.values.ORGAOUNIDADEDESTINO,
        });
        setManagerList(response.data);
    };

    const getVehicleList = async () => {
        const response = await api.post('/listVehiclesByStock', {
            STOCK: formik.values.ESTOQUE,
        });
        console.log("Lista de Veiculos: ", response.data)
        setVehicleList(response.data);
    };

    const getVehicleListAgency = async () => {
        const response = await api.post(`get-vehicles`, { ORGAO: userAgencyId }).then((response) => {
            setVehicleList(response.data);
            console.log("Lista de Veiculos: ", response.data)
            setLoading(false);
        })
            .catch((response: AxiosResponse) => {
                console.log('erro: ', response.status);
                setLoading(false);
            });
    };

    const getFuelVeiculotypes = async (idVeiculo: string) => {
        const response = await api.get(`/fuelsveiculo/${idVeiculo}`);
        console.log("Lista de combustiveis por veiculo: ", response.data)
        setFuelTypesList(response.data);
    };

    const getDrivers = (idVeculo: string) => {
        console.log("ENTROU NA LSITA DOS MOTORISTAS")
        setLoading(true)
        api.get(`motistoristaveiculoveiuclo/${idVeculo}`)
            .then(response => {
                //const data = response.data;
                const data = response.data;

                if (!Array.isArray(data) || data.length === 0) {
                    console.warn("Nenhum motorista encontrado.");
                    setLoading(false);
                    return;
                }

                console.log("Motoristas recebidos > ", data);

                setDriverList(data.map((item) => ({
                    ID: item.FT_MOTORISTA,
                    NOME: item.DESCRICAOMOTORISTA,
                    ORGAO: userAgencyId,
                    DATANASCIMENTO: '',
                    CPF: '',
                    CNH: '',
                    VALIDADECNH: '',
                    CATEGORIACNH: '',
                    SENHA: '',
                    ORGAOUNIDADE: '',
                })));
                //setDriverList(driverList)

                console.log("driverList: ", driverList)


                setLoading(false);
            })
            .catch((response: AxiosResponse) => {
                console.log('erro: ', response.statusText);
                setLoading(false);
            });
        setLoading(false);
    };

    const getCreditoresListAgency = async () => {
        console.log("criando lista de postos userAgenci: ",userAgencyId)
        const response = await api.get(`creditorsagency/${userAgencyId}`).then((response) => {
            console.log("criando lista de psotos: ",response.data)
            setCreditorsList(response.data);
            setLoading(false);
        })
            .catch((response: AxiosResponse) => {
                console.log('erro consulta do posto: ', response.status);
                setLoading(false);
            });
    };

    const getPriorityList = async () => {
        const response = await api.get('prioritys');
        setPriotityList(response.data);
    };

    const getStocksList = async () => {
        const response = await api.post(`/stocks/${userAgencyId}`);
        console.log("Lista de estoques: ", response.data)
        setStocksList(response.data);
    };

    const getFueltypes = async () => {
        const response = await api.get(`/fuels/${userAgencyId}`);
        console.log("1 -Lista de combustiveis: ", response.data)
        setFuelTypesList(response.data);
    };

    const getValorCombustivel = async (idCredor: string, idTipoCombustivel: string): Promise<number> => {
        if (!idCredor || !idTipoCombustivel) return 0;
        try {
            const res = await api.get(`/credortipocombustivelvaloratualtipocombustivel/${idCredor}/${idTipoCombustivel}`);
            console.log("Valor combustível credor/tipo:", res.data);
            const data = Array.isArray(res.data) ? res.data[0] : res.data;
            return Number(data?.VALOR || data?.PRECOVENDA || data?.PRECOCUSTO || 0);
        } catch (err) {
            console.error("Erro ao buscar valor do combustível:", err);
            return 0;
        }
    };

    const unitys = unityList.map(unity => {
        return { label: unity.NOME, value: unity.ID };
    });

    const prioritys = priorityList.map(priority => {
        return { label: priority.DESCRICAO, value: priority.ID };
    });

    const vehicles = vehicleList.map(vehicle => {
        return { label: vehicle.PLACA + " | " + vehicle.DESCRICAO, value: vehicle.ID };
    });

    const creditors = creditorsList.map(creditors => {
        console.log("passei aqui")
        return { label: creditors.CPF_CNPJ + " | " + creditors.NOME, value: creditors.ID };
    });

    const motoristas = driverList.map(motoristas => {
        return { label: motoristas.NOME, value: motoristas.ID };
    });

    const managers = managerList.map(manager => {
        return { label: manager.NOME, value: manager.ID };
    });

    const stocks = stocksList.map(stock => {
        return { label: stock.NOME, value: stock.ID };
    });

    const fuels = fuelTypesList.map(fuels => {
        return { label: fuels.DESCRICAO, value: fuels.ID };
    });

    useEffect(() => {
        getVehicleListAgency();
        getCreditoresListAgency();
    }, []);

    useEffect(() => {
        getUnityList();
        getPriorityList();
        getStocksList();
        getFueltypes();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userAgencyId]);

    useEffect(() => {
        if (formik.values.ORGAOUNIDADEDESTINO !== '') {
            getManagerList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.ORGAOUNIDADEDESTINO]);

    useEffect(() => {
        if (formik.values.ESTOQUE !== '') {
            getVehicleList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.ESTOQUE]);

    return {
        getDemandData: {
            formik,
            formikCombustivel,
            unitys,
            prioritys,
            vehicles,
            creditors,
            motoristas,
            getDrivers,
            getFuelVeiculotypes,
            getValorCombustivel,
            managers,
            stocks,
            fuels,
            loading,
            setLoading,
            toast,
            deleteDemand,
            rejectDemandAdmin,
            driverList,
            response,
        },
        dataResponse: {
            response,
        },
    };
};

export default DemandController;
